import React from "react";
import PropTypes from "prop-types";
import { ArrowDown, ArrowUp, Badge } from "@opendate-app/setlist";

const linkStyle = { color: "var(--sl-text-primary)", fontWeight: 600, textDecoration: "none" };
const viewLinkStyle = { color: "var(--sl-text-brand)", fontWeight: 600, textDecoration: "none", whiteSpace: "nowrap" };

export const TrendBadge = ({ trend }) => {
  const up = trend >= 0;
  return (
    <Badge size="sm" color={up ? "success" : "error"} icon={up ? ArrowUp : ArrowDown}>
      {Math.abs(trend)}%
    </Badge>
  );
};

export const FansCount = ({ count }) => (
  <span style={{ whiteSpace: "nowrap" }}>
    <span style={{ color: "var(--sl-text-primary)", fontWeight: 600 }}>{Number(count || 0).toLocaleString()}</span>{" "}
    <span style={{ color: "var(--sl-text-tertiary)" }}>fans</span>
  </span>
);

export const ViewLink = ({ href, label }) => (
  <a href={href} style={viewLinkStyle} aria-label={label}>View →</a>
);

TrendBadge.propTypes = { trend: PropTypes.number.isRequired };
FansCount.propTypes = { count: PropTypes.number };
ViewLink.propTypes = { href: PropTypes.string.isRequired, label: PropTypes.string.isRequired };

export const segmentColumns = (teamId, header) => [
  {
    key: "name",
    header,
    primary: true,
    width: "220px",
    render: (segment) => <a href={`/teams/${teamId}/segments/${segment.id}`} style={linkStyle}>{segment.name}</a>,
  },
  { key: "definition", header: "Definition", render: (segment) => <span style={{ color: "var(--sl-text-tertiary)" }}>{segment.definition}</span> },
  { key: "count", header: "Fans", align: "right", width: "120px", render: (segment) => <FansCount count={segment.count} /> },
  {
    key: "trend",
    header: "Trend",
    align: "center",
    width: "88px",
    render: (segment) => (typeof segment.trend === "number" ? <TrendBadge trend={segment.trend} /> : null),
  },
  {
    key: "view",
    header: "",
    align: "right",
    width: "88px",
    render: (segment) => <ViewLink href={`/teams/${teamId}/segments/${segment.id}`} label={`View ${segment.name}`} />,
  },
];
